// filters for cefi transactions
import { Transaction, isCefiInfoTx, isDefiInfoTx } from "@cede/types";

export type FilterFunction<T> = (element: T) => boolean;

export function applyFilters<T>(data: T[], filters: FilterFunction<T>[]): T[] {
  if (filters.length === 0) {
    return data;
  }

  return data.filter((element) => filters.every((filter) => filter(element)));
}

export const tokenSymbolFilter =
  (tokenSymbol: string): FilterFunction<Transaction> =>
  (tx: Transaction) => {
    const txSymbols: string[] = [];
    if (isCefiInfoTx(tx.from)) txSymbols.push(tx.from.transaction.tokenSymbol);
    if (isCefiInfoTx(tx.to)) txSymbols.push(tx.to.transaction.tokenSymbol);
    if (isDefiInfoTx(tx.from)) txSymbols.push(...tx.from.transaction.tokens.map((token) => token.tokenSymbol));
    if (isDefiInfoTx(tx.to)) txSymbols.push(...tx.to.transaction.tokens.map((token) => token.tokenSymbol));
    return txSymbols.includes(tokenSymbol);
  };

export const txTypeFilter =
  (txType: string): FilterFunction<Transaction> =>
  (tx: Transaction) => {
    return tx.type.toString() === txType;
  };

export const startTimeFilter =
  (startTime: number): FilterFunction<Transaction> =>
  (tx: Transaction) => {
    if (isCefiInfoTx(tx.from)) return tx.from.transaction.timestamp >= startTime;
    if (isCefiInfoTx(tx.to)) return tx.to.transaction.timestamp >= startTime;
    if (isDefiInfoTx(tx.from)) return tx.from.transaction.timestamp >= startTime;
    if (isDefiInfoTx(tx.to)) return tx.to.transaction.timestamp >= startTime;

    // default case cannot happen
    return false;
  };
